export enum BonusType {
  CASINO_STANDARD = '1',
  SPORTS_STANDARD = '2',
  // FREE_PLAY = '3',
  FREE_SPINS = '4',
  BETSOFT_CASINO = '5',
}
